<template>
    <img :src="qrcode222" alt="QR code" v-if="text" />
</template>

<script>
export default {
    name: 'QrImage',
};
</script>
<script setup>
import { ref } from 'vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';

const props = defineProps({
    text: {
        type: String,
        default: null,
        required: false,
    },
});
const text = ref('text-to-encode');
const qrcode222 = useQRCode(props.text);
</script>
